import Vue from 'vue';
import Vuex from 'vuex';

import accounts from './modules/accounts';
import agentBots from './modules/agentBots';
import agents from './modules/agents';
import aiAgents from './modules/aiAgents';
import articles from './modules/helpCenterArticles';
import attributes from './modules/attributes';
import auth from './modules/auth';
import auditlogs from './modules/auditlogs';
import automationFlows from './modules/automationFlows';
import automationFlowDirectories from './modules/automationFlowDirectories';
import automationFlowLabels from './modules/automationFlowLabels';
import bulkActions from './modules/bulkActions';
import billingEntitlements from './modules/billingEntitlements';
import campaigns from './modules/campaigns';
import cannedResponse from './modules/cannedResponse';
import categories from './modules/helpCenterCategories';
import contactConversations from './modules/contactConversations';
import contactLabels from './modules/contactLabels';
import contactNotes from './modules/contactNotes';
import contacts from './modules/contacts';
import companies from './modules/companies';
import flipLeads from './modules/flipLeads';
import franchises from './modules/franchises';
import conversationLabels from './modules/conversationLabels';
import conversationMetadata from './modules/conversationMetadata';
import conversationNotes from './modules/conversationNotes';
import conversationPage from './modules/conversationPage';
import conversations from './modules/conversations';
import conversationSearch from './modules/conversationSearch';
import conversationStats from './modules/conversationStats';
import conversationTypingStatus from './modules/conversationTypingStatus';
import conversationWatchers from './modules/conversationWatchers';
import surveys from './modules/surveys';
import surveyResponses from './modules/surveyResponses';
import customViews from './modules/customViews';
import customRole from './modules/customRole';
import customReports from './modules/customReports';
import dashboardApps from './modules/dashboardApps';
import dataTransfers from './modules/dataTransfers';
import goals from './modules/goals';
import globalConfig from 'shared/store/globalConfig';
import inboxAssignableAgents from './modules/inboxAssignableAgents';
import inboxes from './modules/inboxes';
import inboxMembers from './modules/inboxMembers';
import integrations from './modules/integrations';
import internalChat from './modules/internalChat';
import kanban from './modules/kanban';
import labels from './modules/labels';
import metaLeadgen from './modules/metaLeadgen';
import minimax from './modules/minimax';
import notifications from './modules/notifications';
import releaseNotes from './modules/releaseNotes';
import portals from './modules/helpCenterPortals';
import reports from './modules/reports';
import sla from './modules/sla';
import tasks from './modules/tasks';
import teamMembers from './modules/teamMembers';
import teams from './modules/teams';
import userNotificationSettings from './modules/userNotificationSettings';
import webhooks from './modules/webhooks';
import draftMessages from './modules/draftMessages';
import SLAReports from './modules/SLAReports';
import webphone from './modules/webphone';
import uazapi from './modules/uazapi';
import scheduledMessages from './modules/scheduledMessages';

const plugins = [];

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    accounts,
    agentBots,
    agents,
    aiAgents,
    articles,
    attributes,
    auth,
    automationFlows,
    automationFlowDirectories,
    automationFlowLabels,
    auditlogs,
    billingEntitlements,
    bulkActions,
    campaigns,
    cannedResponse,
    categories,
    contactConversations,
    contactLabels,
    contactNotes,
    contacts,
    companies,
    flipLeads,
    franchises,
    conversationLabels,
    conversationMetadata,
    conversationNotes,
    conversationPage,
    conversations,
    conversationSearch,
    conversationStats,
    conversationTypingStatus,
    conversationWatchers,
    surveys,
    surveyResponses,
    customViews,
    customRole,
    customReports,
    dashboardApps,
    dataTransfers,
    goals,
    globalConfig,
    inboxAssignableAgents,
    inboxes,
    inboxMembers,
    integrations,
    internalChat,
    kanban,
    labels,
    metaLeadgen,
    minimax,
    notifications,
    releaseNotes,
    portals,
    reports,
    teamMembers,
    teams,
    tasks,
    userNotificationSettings,
    webhooks,
    draftMessages,
    sla,
    slaReports: SLAReports,
    webphone,
    uazapi,
    scheduledMessages,
  },
  plugins,
});
